import React, { Suspense, lazy, useState } from 'react';
import { ARROW_NEXT_WHITE, LOGO_MMWSS, ZAKAT_LOGO } from '../../common/images-s3';

const ImageLoader = lazy(() => import('../../common/image-loader'));

const Header = ({ handleBack, backBtn, handleBackToHome, hideHeader }) => {
    const [isHomeButtonVisible, setIsHomeButtonVisible] = useState(true);

    if (hideHeader) return null;

    return (
        <header className='header' id="header">
            <div className="container">
                <ul className="header-ul">
                    <li className="header-li header-back">
                        {backBtn && (
                            <button className="btn btn-transparent header-menu" onClick={handleBack}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="11.999" height="20.5" viewBox="0 0 11.999 20.5">
                                    <g id="Button" transform="translate(-0.5 -0.5)">
                                        <path id="Arrow" d="M9.537,20.083.292,10.946a.975.975,0,0,1,0-1.392L9.537.417a1.456,1.456,0,0,1,2.041,0,1.415,1.415,0,0,1,0,2.016L3.669,10.25l7.909,7.815a1.417,1.417,0,0,1,0,2.017,1.456,1.456,0,0,1-2.041,0" transform="translate(0.5 0.5)" fill="#fff" />
                                    </g>
                                </svg>
                            </button>
                        )}
                    </li>

                    <li className="header-li header-logo">
                        <button className="btn btn-transparent header-menu" onClick={handleBackToHome}>
                            <Suspense fallback={null}>
                                <ImageLoader type="image" src={ZAKAT_LOGO} />
                            </Suspense>
                        </button>
                    </li>

                    <li className="header-li header-home">
                        {isHomeButtonVisible && (
                            <button className="btn btn-transparent header-menu" onClick={handleBackToHome}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37">
                                    <g id="Group_14810" data-name="Group 14810" transform="translate(-318 -133)">
                                        <circle id="Ellipse_936" data-name="Ellipse 936" cx="18.5" cy="18.5" r="18.5" transform="translate(318 133)" fill="#fff" opacity="0.35" />
                                        <path id="home-svgrepo-com_5_" data-name="home-svgrepo-com (5)" d="M22.573,14.371l-8.049-7.48a4.579,4.579,0,0,0-6.16,0L.27,14.371a.863.863,0,0,0,0,1.254,1.032,1.032,0,0,0,1.349,0l.585-.543v9.486c0,1.63,1.3,2.633,3.462,2.633,2.068,0,3.552-1.086,3.552-2.633V19.093c0-.543.27-1.463,2.2-1.463s2.2.919,2.2,1.463v5.474a2.286,2.286,0,0,0,.764,1.713,4.074,4.074,0,0,0,2.788.919c2.158,0,3.462-1,3.462-2.633V15.082l.585.543a.953.953,0,0,0,.675.251,1.034,1.034,0,0,0,.675-.251.863.863,0,0,0,0-1.254Zm-3.822,10.2c0,.585-.54.878-1.574.878a2.219,2.219,0,0,1-1.439-.418.637.637,0,0,1-.18-.5V19.093c0-1.964-1.619-3.218-4.092-3.218s-4.092,1.254-4.092,3.218v5.474c0,.878-1.574.878-1.664.878-1.574,0-1.574-.627-1.574-.878V13.326L9.713,8.145a2.634,2.634,0,0,1,3.507,0L18.8,13.326Z" transform="translate(325.5 134.801)" fill="#fff" stroke="#fff" strokeWidth="0.2" />
                                    </g>
                                </svg>
                            </button>
                        )}
                    </li>
                </ul>
            </div>
        </header>
    );
};

export default Header;